import React, { useEffect, useState } from 'react'
import styles from './CurrentTicket.module.css'
import Button from '@mui/material/Button'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTicket, sendSms } from '../Tickets/ticketSlice'
import { useParams } from 'react-router-dom'
import Loader from '../subsidiary/Loader/Loader'
import { getUserData } from '../Profile/profileSlice'
import OutgoingMessage from './OutgoingMessage'
import IncomingMessage from './IncomingMessage'
import GoBack from '../subsidiary/GoBack/GoBack'
import HeartRating from "../Rating/Rating";

const normalizeTicketStatus = (ticket) => {
  const raw =
    ticket?.status?.name ||
    ticket?.status?.title ||
    ticket?.status_name ||
    ticket?.state ||
    ticket?.state_name ||
    ticket?.ticket_state ||
    ticket?.ticket_status?.name ||
    ticket?.ticket_status?.title ||
    ticket?.ticket_status ||
    null;

  if (raw) return String(raw);

  if (ticket?.closed) return 'закрыт';

  const messages = Array.isArray(ticket?.messages) ? ticket.messages : [];
  if (messages.length <= 1) return 'новый';

  const last = messages[messages.length - 1];
  const authorId = last?.user_id;
  const requesterId = ticket?.user_id || ticket?.author_id || ticket?.created_by;

  if (requesterId != null && authorId === requesterId) {
    return 'ожидает ответа';
  }

  return 'есть ответ';
};

const getStatusStyle = (statusLabel, isClosed) => {
  const normalized = statusLabel?.toLowerCase() || '';

  if (
    normalized.includes('отказ') ||
    normalized.includes('отказан') ||
    normalized.includes('отклон') ||
    normalized.includes('не соглас') ||
    normalized.includes('не принято')
  ) {
    return { backgroundColor: '#FFE5E3', color: '#EF2E25' };
  }
  if (normalized.includes('принято') || normalized.includes('принят')) {
    return { backgroundColor: '#E2EEDD', color: '#A1C261' };
  }
  if (normalized.includes('в работе') || normalized.includes('работа') || normalized.includes('обработ')) {
    return { backgroundColor: '#E8EFFB', color: '#2F6FED' };
  }
  if (normalized.includes('нов')) {
    return { backgroundColor: '#E8EFFB', color: '#2F6FED' };
  }
  if (normalized.includes('ожида')) {
    return { backgroundColor: '#FFE8E3', color: '#F36D52' };
  }
  if (normalized.includes('ответ')) {
    return { backgroundColor: '#E2EEDD', color: '#A1C261' };
  }
  if (normalized.includes('доработ')) {
    return { backgroundColor: '#FFE8E3', color: '#F36D52' };
  }
  if (normalized.includes('закры') || isClosed) {
    return { backgroundColor: '#F4F4F4', color: '#8F9191' };
  }
  return { backgroundColor: '#E2EEDD', color: '#A1C261' };
};


function CurrentTicket(props) {
  const dispatch = useDispatch()
  const id = useParams().id
  const [message, setMessage] = useState('')
  const token = useSelector(state => state.loginSlice.token)
  const user = useSelector(state => state.profileSlice.user)
  const currentTicket = useSelector(state => state.ticketSlice.ticket)
  const isLoaded = useSelector(state => state.ticketSlice.isLoaded)
  const handleSendSms = () => {
    if (!message.trim()) {
      return;
    }
    if (currentTicket.closed) {
      window.showAlert({title: 'Нельзя отправить сообщение в закрытый тикет', type: 'error'})
      return;
    }
    dispatch(sendSms({ token, id, message })).then((params) => {
      if (params.error) {
        window.showAlert({title: 'Для начала нужно получить ответ от модератора', type: 'error'})
      }
      else {
        setMessage('')
        // Refresh ticket to show new message
        dispatch(fetchTicket({ id }))
      }
    })
  }
  useEffect(() => {
    if (token && id) {
      dispatch(getUserData({ token }))
      dispatch(fetchTicket({ id }))
    }
  }, [dispatch, token, id])
  return (
    <section className="main">
      {isLoaded ?
        <div className="content-wrapper">
          <GoBack text={'Назад'} />
          <div className="page-title-container">
            <h1 className="page-title ">
              Тикет № {currentTicket.id}
              <span
                className={styles.statusPill}
                style={getStatusStyle(normalizeTicketStatus(currentTicket), !!currentTicket.closed)}
              >
                {normalizeTicketStatus(currentTicket)}
              </span>
            </h1>
          </div>
          <div>
            {currentTicket.messages ? currentTicket.messages.map(message => {
              return message.user_id === user.id ? <OutgoingMessage message={message.message} /> : <IncomingMessage message={message.message} />
            }) : ''}
            <div style={{margin: '30px 0'}}>
              {currentTicket.closed
                  ? <> <span style={{marginBottom: '20px', fontSize: '13px', color: 'rgba(0, 0, 0, 0.33)'} }>Оцените работу оператора</span>
                      <HeartRating id={id} raiting={currentTicket.rating}/>
                    </>
                  : null
              }

            </div>
            {!currentTicket.closed && (
              <div style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column' }}>
                <textarea
                  className={styles.messageField}
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                  placeholder="Сообщение"
                  disabled={currentTicket.closed}
                />
                <Button 
                  onClick={handleSendSms} 
                  className={styles.sendBtn} 
                  variant="contained"
                  disabled={currentTicket.closed || !message.trim()}
                >
                  Отправить
                </Button>
              </div>
            )}
          </div>
        </div> : <Loader />}
    </section>
  )
}

export default CurrentTicket
